import { render, staticRenderFns } from "./categoryOld.vue?vue&type=template&id=52171c1b&"
import script from "./categoryOld.vue?vue&type=script&lang=js&"
export * from "./categoryOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports